import { Component, HostListener, Input } from '@angular/core';

@Component({
  selector: 'app-control-page-card-expand',
  templateUrl: './control-page-card-expand.component.html',
  styleUrl: './control-page-card-expand.component.scss',
})
export class ControlPageCardExpandComponent {

  @Input() id: string;

  @Input() open = true;

  @HostListener('click', ['$event'])
  listenerToggleEvent(event: Event) {
    event.stopPropagation();
    this.toggle();
  }

  /**
   * Toggle method allow to open or close the sidebar card
   * it's used by listenerToggleEvent or we can call outside to expand with parent component
   */
  toggle() {
    this.open = !this.open;
  }

}
